export const PARTNERS = [
  {
    id: 'upsolut',
    name: 'UPSOLUT',
    logo: '/images/partners/upsolut.svg',
    url: 'https://upsolut.ru/',
  },
];
